import { addActionBarItem } from '@vendure/admin-ui/core';
import { firstValueFrom } from 'rxjs';
import gql from 'graphql-tag';

const SYNC_CUSTOMER_MUTATION = gql`
    mutation SyncCustomer($customerId: ID!) {
        syncCustomer(customerId: $customerId)
    }
`;

export default [
    addActionBarItem({
        id: 'sync-customer-btn',
        locationId: 'customer-detail',
        icon: 'refresh',
        label: 'Sincronizar Cliente',
        onClick: async (event, context) => {
            const customerId = context.route.snapshot.params.id;

            if (!customerId) {
                context.notificationService.error(
                    'ID do cliente não encontrado na rota.'
                );
                return;
            }

            try {
                const response: any = await firstValueFrom(
                    context.dataService.mutate(SYNC_CUSTOMER_MUTATION, {
                        customerId,
                    })
                );

                context.notificationService.success(
                    'Sincronização iniciada com sucesso!'
                );
            } catch (error: any) {
                console.error('Erro na mutation syncCustomer:', error);
                context.notificationService.error(
                    'Erro ao sincronizar cliente: ' +
                        (error.message || 'Erro desconhecido')
                );
            }
        },
        requiresPermission: 'UpdateCustomer',
    }),
];
